const channels = [
  {
    title: 'Channels',
    icon: 'Share2Icon',
    enableFeature: true,
    children: [
      {
        title: 'Channels',
        route: 'channels',
        enableFeature: true,
      },
    ],
  },
]

export default channels
